import { Classes, HTMLSelect } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import classNames from "classnames";
import dropRight from "lodash/dropRight";
import React, { useRef, useEffect, useState } from "react";

import Header from "./AppHeader";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import "@toast-ui/editor/dist/toastui-editor.css";

import { Editor, EventMapping } from "@toast-ui/react-editor";

import "react-mosaic-component/react-mosaic-component.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {
  Corner,
  createBalancedTreeFromLeaves,
  getLeaves,
  getNodeAtPath,
  getOtherDirection,
  getPathToCorner,
  Mosaic,
  MosaicDirection,
  MosaicNode,
  MosaicParent,
  MosaicWindow,
  MosaicZeroState,
  updateTree,
  ExpandButton,
  RemoveButton,
} from "react-mosaic-component";

import { CloseAdditionalControlsButton } from "./CloseAdditionalControlsButton";
import { String } from "lodash";

// tslint:disable no-console

// tslint:disable-next-line no-var-requires
// tslint:disable-next-line no-var-requires
const { version } = require("../package.json");

let windowCount = 1;

export const THEMES = {
  ["Blueprint"]: "mosaic-blueprint-theme",
  ["Blueprint Dark"]: classNames("mosaic-blueprint-theme", Classes.DARK),
  ["None"]: "",
};

export type Theme = keyof typeof THEMES;

const additionalControls = React.Children.toArray([
  <CloseAdditionalControlsButton />,
]);

const EMPTY_ARRAY: any[] = [];

export interface ClickInfo {
  url?: string;
  title?: string;
  retrieval?: string;
}

export interface ExampleAppState {
  currentNode: MosaicNode<number> | null;
  currentTheme: Theme;

  currentUrl: ClickInfo;
  saves: ClickInfo[];
}

const WRITING_WINDOW = 1;
const READING_WINDOW = 2;
const SAVES_WINDOW = 3;

function parse_text_fragment(link: any) {
  var hash_parts = link.split(":~:text=");
  if (hash_parts.length == 2) {
    return decodeURIComponent(hash_parts[1]);
  } else {
    return "";
  }
}

export default class ExampleApp extends React.PureComponent<
  {},
  ExampleAppState
> {
  state: ExampleAppState = {
    currentNode: {
      direction: "row",
      first: WRITING_WINDOW,
      second: {
        direction: "column",
        first: READING_WINDOW,
        second: SAVES_WINDOW,
        splitPercentage: 80,
      },
      splitPercentage: 50,
    },
    currentTheme: "Blueprint",
    currentUrl: {},
    saves: [],
  };
  editorRef: React.RefObject<Editor>;
  currentMarkdown: string;

  constructor(props: any) {
    super(props);
    this.editorRef = React.createRef();
    this.currentMarkdown = "";
  }

  componentDidMount() {
    // Load text stored in local storage, if any.
    var editor = this.editorRef!.current?.getInstance();
    this.currentMarkdown = editor!.getMarkdown()!;
    if (this.currentMarkdown === "") {
      var savedMarkdown = window.localStorage.getItem("markdown");
      if (savedMarkdown) {
        editor?.setMarkdown(savedMarkdown);
        this.currentMarkdown = savedMarkdown;
      }
    }
    // Check for new text every 2 seconds.
    setInterval(() => {
      this.saveIfChanged();
    }, 2000);
  }

  saveIfChanged() {
    // Save text to local storage, if anything's changed.
    var newMarkdown: string =
      this.editorRef!.current?.getInstance().getMarkdown()!;
    if (newMarkdown != this.currentMarkdown) {
      // Text has changed.
      window.localStorage.setItem("markdown", newMarkdown);
      this.currentMarkdown = newMarkdown;
    }
  }

  componentDidUpdate() {
    // Disable iframes from taking over mouse pointer movements during
    // tiling manager operations.
    document.onmousedown = function (ev: MouseEvent) {
      document.querySelectorAll("iframe").forEach((iframe) => {
        iframe.style.pointerEvents = "none";
      });
    };
    document.onmouseup = function (ev: MouseEvent) {
      document.querySelectorAll("iframe").forEach((iframe) => {
        iframe.style.pointerEvents = "auto";
      });
    };
    // Scroll to relevant text fragment.
    document.querySelectorAll("iframe").forEach((iframe) => {
      const sentence = parse_text_fragment(iframe.src);
      if (sentence.length == 0) {
        return;
      }
      iframe.addEventListener("load", function (e: Event) {
        const target = e.target as HTMLIFrameElement;
        target.contentWindow?.postMessage(
          {
            text_fragment: sentence,
          },
          "*"
        );
      });
    });
    // // Bubble selection events from iframes to top level window.
    // document.querySelectorAll('iframe').forEach((iframe) => {
    //   var iframe_window = iframe.contentWindow;
    //   if(iframe_window != null){
    //     // var iframe_document = iframe_window.document;
    //     // if (!iframe_document){
    //     //   return;
    //     // }
    //     iframe_window.onmouseup = function(e){
    //       var selection = iframe_window!.getSelection();
    //       if (selection && window.top){
    //         window.top.postMessage({
    //           selection: selection.toString()
    //         }, '*');
    //       }
    //     }
    //   }
    // });
  }

  render() {
    let click = this.state.currentUrl;
    let saves = this.state.saves;
    var deleteSave = (url: string) => this.deleteSave.bind(this, url);

    function count_to_component(count: number, path: any) {
      var window_content;
      var title = "";

      if (count === READING_WINDOW) {
        window_content = "";
        if (click) {
          var url = click.url;
          title = click.title || "";
          if (url) {
            // If it's an Omni browse URL, override with raw html.
            var url_obj = new URL(url);
            if (url_obj.host == "omnilabs.ai") {
              var docid = url_obj.pathname.split("/browse/")[1];
              var sentence = url_obj.searchParams.get("sentence");
              url = "https://omnilabs.ai/raw_html/" + docid + "/" + sentence;
            }
            if (!url.startsWith("https")) {
              console.log("Augmenting with HTTPS", url);
              url = "https://" + url.replace("http://", "");
            }
            // const onIframeLoad = (e: Event) => {
            //   const iframe = e.target as HTMLIFrameElement;
            //   iframe.contentWindow.postMessage({
            //     text_fragment: sentence
            //   }, '*');
            // };
            window_content = <iframe src={url} className="browse"></iframe>;
          }
        }
      } else if (count === WRITING_WINDOW) {
        window_content = (
          <Editor
            previewStyle="vertical"
            height="100%"
            initialEditType="wysiwyg"
            initialValue=""
            ref={this.editorRef}
          />
        );
        title = "Text Editor";
      } else if (count === SAVES_WINDOW) {
        title = "Result History";
        window_content = (
          <TableContainer
            component={Paper}
            sx={{
              height: "100%",
              overflowY: "scroll",
            }}
          >
            <Table
              sx={{ width: "100%", tableLayout: "fixed" }}
              size="small"
              aria-label="a dense table"
            >
              <TableBody>
                {saves.map((click) => (
                  <TableRow
                    key={click.url}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      <div className="history">
                        <div className="history">{click.retrieval}</div>
                        <div className="history">
                          <a href={click.url}>{click.title}</a>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell align="right" style={{ width: "60px" }}>
                      <IconButton
                        aria-label="close"
                        onClick={deleteSave(click.url || "")}
                      >
                        <CloseIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        );
      } else {
        window_content = (
          <div className="example-window">
            <h1>{`Window ${count}`}</h1>
          </div>
        );
      }

      return (
        <MosaicWindow<number>
          toolbarControls={count <= 3 ? [<ExpandButton />] : null}
          title={title}
          path={path}
          onDragStart={() => console.log("MosaicWindow.onDragStart")}
          onDragEnd={(type) => console.log("MosaicWindow.onDragEnd", type)}
        >
          {window_content}
        </MosaicWindow>
      );
    }

    return (
      <React.StrictMode>
        <div className="container">
          <Header />
          <div className="react-mosaic-example-app">
            <Mosaic<number>
              renderTile={count_to_component.bind(this)}
              zeroStateView={<MosaicZeroState createNode={this.createNode} />}
              value={this.state.currentNode}
              onChange={this.onChange}
              onRelease={this.onRelease}
              className={THEMES[this.state.currentTheme]}
            />
          </div>
          <div id="under_sidebar">
            Please <a href="https://chrome.google.com/webstore/detail/omni/mlcoidohpcjfjnknjjggenjccckcgmpn">install our extension</a>
            &nbsp;to write with Omni.
          </div>
        </div>
      </React.StrictMode>
    );
  }

  private onChange = (currentNode: MosaicNode<number> | null) => {
    this.setState({ currentNode });
  };

  private onRelease = (currentNode: MosaicNode<number> | null) => {
    console.log("Mosaic.onRelease():", currentNode);
  };

  private createNode = () => ++windowCount;

  private autoArrange = () => {
    const leaves = getLeaves(this.state.currentNode);

    this.setState({
      currentNode: createBalancedTreeFromLeaves(leaves),
    });
  };

  public addEmptyToTopRight = () => {
    this.addToRight({});
  };

  private deleteSave(url: string) {
    this.setState((prevState) => {
      return {
        saves: prevState.saves.filter((el) => el.url !== url),
      };
    });
  }

  public addToRight = (click: ClickInfo) => {
    this.setState((prevState) => {
      // Add click to the start of history, deduplicating by URL.
      const saves = prevState.saves;
      const new_saves = [click];
      for (let i = 0; i < saves.length; i++) {
        if (saves[i].url !== click.url) {
          new_saves.push(saves[i]);
        }
      }

      return {
        currentUrl: click,
        saves: new_saves,
      };
    });
  };
}
